import gql from 'graphql-tag';

export default gql(`
mutation AddSubscriber($email: String!, $createdAt: String) {
  addSubscriber(email: $email, createdAt: $createdAt) {
    id
    email
    createdAt
    status
    notified
  }
}`);



// WEBPACK FOOTER //
// ./src/graphql/MutationNewSubscriber.js